module.exports = "pegasus/assets/theme5/facebook-icon.png";